import { render, staticRenderFns } from "./user-post.vue?vue&type=template&id=09bb83cf"
import script from "./user-post.vue?vue&type=script&lang=js"
export * from "./user-post.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports